import ShipperPortal from "../ShipperPortal";

/* ============================================================================
 * ShipperShipments — thin wrapper around the admin ShipperPortal module.
 *
 * Per spec, the Shipper Portal's Shipments view must mirror the EXACT
 * layout of the admin's "Shipper Portal" module (NOT the general
 * ShipmentRegistry): summary cards for Borradores / Enviadas /
 * Aceptadas / Rechazadas, list of proformas, embarque modal with
 * pallet manifest, etc.
 *
 * Passing `lockSupplierId` to ShipperPortal:
 *   * Pins the resolved shipper to the user's own supplier (so they
 *     can never see another tenant's data; the previous resolver
 *     fell back to "first shipper" which is fine for admin but
 *     dangerous for shippers).
 *   * Activates `shipperMode` downstream — the per-pallet growerCode
 *     field becomes a SearchSelect populated with this shipper's own
 *     growers (label format "001 - Juan Sandoval") instead of a
 *     free-text input.
 *   * Loads the growers list scoped to this supplier and threads it
 *     down through EmbarqueModal → ProformaForm.
 *
 * Records visible are exactly the rows in the `shipper_shipments`
 * Supabase table whose supplierId matches this shipper. Imports from
 * Excel and shipments captured directly in the admin's general
 * Shipments module live in a different table (`shipments`) and never
 * surface here.
 *
 * `supplierId` is the LEGACY id resolved by ShipperPortalShell from
 * profile.supplier_id.
 * ============================================================================ */
export default function ShipperShipments({ supplierId, lang, profile, openLot, onLotOpened }) {
  return <ShipperPortal lang={lang} lockSupplierId={supplierId} profile={profile} openLot={openLot} onLotOpened={onLotOpened} />;
}
